var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.474 6.72 9.27.514a1.84 1.84 0 0 0-2.538 0L.526 6.72A1.771 1.771 0 0 0 0 8a1.749 1.749 0 0 0 .526 1.257l6.205 6.206a1.795 1.795 0 0 0 2.538 0l6.205-6.206A1.748 1.748 0 0 0 16 8a1.773 1.773 0 0 0-.526-1.28ZM7.143 3.989a.857.857 0 0 1 1.714 0v3.428a.857.857 0 0 1-1.714 0V3.99Zm.857 8a1.143 1.143 0 1 1 0-2.287 1.143 1.143 0 0 1 0 2.287Z",
    fill: "#AF2828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.50d3a33a407807e0a2ffafeca2a673f8.svg";
export { ForwardRef as ReactComponent };